import { validCookieId, getHeaders } from '/source/js/utils/validCookie';
import { addApplyCouponGtmTag } from '/source/js/gtm/IsaGtmCommerce';

const CART_SESSION_API = '/sitecore/api/ssc/rw/isagenix/cartapi';

const PRESALE_API = '/sitecore/api/ssc/rw/isagenix/productapi/presalequantitycheck';

export async function presaleQuantityCheck(request) {
    return $.ajax({
        type: 'POST',
        url: PRESALE_API,
        headers: getHeaders(),
        data: request
    });
}

export async function addPackToCart(request) {
    return $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/addpacktocart`,
        headers: getHeaders(),
        data: request
    });
}

export async function addToCart(request) {
    return $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/addtocart`,
        headers: getHeaders(),
        data: request
    });
}

export async function addKitToCart(request) {
    return $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/addkittocart`,
        headers: getHeaders(),
        data: request
    });
}

export async function updateCartLine(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/updatecartline`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function updateMembershipSkuCartLine(request) {
    console.log('started... updateMembershipSkuCartLine');
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/updateMembershipSkuCartLine`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function switchCartContext(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/switchcartcontext`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function getProductEditUrl(productId, cartLineId) {
    return $.ajax({
        type: 'GET',
        url: `${CART_SESSION_API}/getProductEditUrl`,
        data: {
            productId: productId,
            cartLineId: cartLineId
        },
        dataType: 'json'
    });
}

export async function editCartLine(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/editcartline`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function editPackCartLine(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/editpackcartline`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function addCouponToCart(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/addCoupontocart`,
        headers: getHeaders(),
        data: request
    });

    // send gtm
    if(result) {
        let errorMsg = '';

        var validationError = result.Messages.find(m => m.Code === 'ValidationError');
        if(validationError) {
            errorMsg = validationError.CommerceCode;
        }

        addApplyCouponGtmTag(request.CouponCode, result.IsSuccessful, errorMsg);
    }

    return validCookieId(result);
}

export function addIsaDeliveryToCart(request) {
    return $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/addIsaDeliveryToCart`,
        headers: getHeaders(),
        data: request
    });
}

export async function removeCouponPromotionFromCart(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/removeCouponPromotionFromCart`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function startCheckout(request) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CART_SESSION_API}/StartCheckout`,
        data: request
    });
    return validCookieId(result);
}

export async function startCheckoutZeroDollar(request) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CART_SESSION_API}/StartCheckoutZeroDollar`,
        data: request
    });
    return validCookieId(result);
}

export async function cartEmptyZeroDollarRedirection() {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CART_SESSION_API}/CartEmptyZeroDollarRedirection`
    });
    return validCookieId(result);
}

export async function getCartFeaturedPromotions(request) {
    const result = await $.ajax({
        headers: getHeaders(),
        type: 'POST',
        url: `${CART_SESSION_API}/getCartFeaturedPromotions`,
        data: request
    });
    return validCookieId(result);
}
export async function validateApplePayMerchant(request) {
    return $.ajax({
        headers: Object.assign({}, { 'Content-Type': 'application/json'}, getHeaders()),
        type: 'POST',
        url: `${CART_SESSION_API}/validateApplePayMerchant`,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}

export function removeShippingParty() {
    return $.ajax({
        headers: getHeaders(),
        type: 'GET',
        url: `${CART_SESSION_API}/removeShippingParty`
    });
}

export function getAvailableCouponsPromotions() {
    return $.ajax({
        headers: Object.assign({}, { 'Content-Type': 'application/json'}, getHeaders()),
        type: 'POST',
        url: `${CART_SESSION_API}/GetAvailableCouponPromotions`,
        contentType: 'application/json',
        dataType: 'json'
    });
}

export function updateQSForMergeCart() {
    var guestCartCookie = $.cookie('GuestCart');
    var anchorTag = document.querySelector(`.navbar-icons__account a.navbar-icons__link.navbar-icons__account-link`);
    if($('#mergecartreturnurl').length && $('#mergecartreturnurl').val().trim() !== '') {
        var mergecartReturnUrl = $('#mergecartreturnurl').val();
        if(guestCartCookie && guestCartCookie != null) {
            if(anchorTag && anchorTag.getAttribute('href')) {
                var currentHref = anchorTag.getAttribute('href');
                var url = new URL(currentHref, window.location.origin);
                url.searchParams.set('ReturnUrl', mergecartReturnUrl);
                anchorTag.href = url;
            }
        } else {
            if(anchorTag && anchorTag.getAttribute('href') && anchorTag.href.toLowerCase().includes(mergecartReturnUrl.toLowerCase())) {
                var currentHrefWithReturn = anchorTag.getAttribute('href');
                var loginurl = new URL(currentHrefWithReturn, window.location.origin);
                loginurl.searchParams.delete('ReturnUrl');
                anchorTag.href = loginurl;
            }
        }
    }
}

export async function saveShopLaterPreference(request) {
    const result = await $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/SaveShopLaterPreference`,
        headers: getHeaders(),
        data: request
    });
    return validCookieId(result);
}

export async function getProductDetails(request) {
    return $.ajax({
        type: 'GET',
        url: `${CART_SESSION_API}/GetProductDetails`,
        headers: getHeaders(),
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function addMultipleProductsToCart(bundleAlternateProductInfo) {
    return $.ajax({
        type: 'POST',
        url: `${CART_SESSION_API}/AddMultipleProductsToCart`,
        headers: getHeaders(),
        data: bundleAlternateProductInfo
    });
}
